module.exports = __webpack_public_path__ + "static/media/TrackFood – 1.df913111.jpg";